<template>
  <div>
    <v-autocomplete
      :value="entity"
      :items="filterEntities"
      :label="$i18n.t(label)"
      @change="changedTo"
      @click:clear="clear"
      :loading="loading"
      :clearable="clearable"
      :rules="rules"
      :search-input.sync="filter"
      ref="select"
      autocomplete="nope"
      :no-filter="true"
      v-if="hide === false"
    >
      <template v-slot:selection="data">
        <div ripple dense class="height32">
          <h5 class="text-title">{{ data.item.name }}</h5>
        </div>
      </template>
      <template v-slot:item="data">
        <v-list-item ripple>
          <v-list-item-content>
            <v-list-item-title>
              {{ data.item.name }}
              <v-icon small v-if="selected(data.item)" style="float:right">mdi-check</v-icon>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider class="mt-2"></v-divider>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { doGet } from "@/store/common/module/apis";
import Themeable from "vuetify/lib/mixins/themeable";

import { Vue, Component, Watch } from "vue-property-decorator";

@Component({
  name: "PaymentModeSelect",
  props: {
    value: {
      default: false,
    },
    corp: {
      default: null,
    },
    label: {
      default: "Payment Modes",
    },
    clearable: {
      default: false,
    },
    autoSelect: {
      default: false,
    },
    hideLone: {
      default: false,
    },
    rules: {
      default: () => [],
    },
  },
})
export default class PaymentModeSelect extends (Vue, Themeable) {
  entity = null;
  entities = [];
  loading = true;
  filter = "";
  hide = false;

  clear() {
    this.filter = "";
    this.entity = null;
    this.$emit("input", null);
  }

  get filterEntities() {
    let filterby = this.filter;
    filterby = filterby != null ? filterby.toLowerCase() : "";
    if (filterby == "") return this.entities;
    const fs = this.entities.filter(function (s) {
      return s.name && s.name.toLowerCase().indexOf(filterby) >= 0;
    });
    return fs;
  }

  changedTo(newVal) {
    this.filter = "";
    if (newVal) {
      this.entity = newVal;
    }
    if (newVal && newVal.name) {
      this.$emit("input", newVal._id);
    }
    if (!newVal) {
      this.$emit("input", null);
    
    }
  }

  selectValue() {
    if (this.entities && this.entities.length == 1 && this.hideLone !== false) {
      this.hide = true;
    }
    if (this.value) {
      for (let i = 0; i < this.entities.length; i++) {
        if (this.entities[i]._id === this.value) {
          this.entity = this.entities[i];
          return;
        }
      }
    }
    if (this.autoSelect !== false) {
      if (this.entities.length == 1) {
        this.entity = this.entities[0];
        this.$emit("input", this.entity._id);
        return;
      }
      for (let i = 0; i < this.entities.length; i++) {
        if (this.entities[i].isDefault == true) {
          this.entity = this.entities[i];
          this.$emit("input", this.entity._id);
          return;
        }
      }
    }
  }

  async init(val) {
    this.filter = "";
    this.loading = true;
    this.entities = await doGet("/api/payment/modes/list");
    this.loading = false;
    this.selectValue();
  }

  async mounted() {
    await this.init(this.corp);
    this.loading = false;
  }

  selected(val) {
    if (
      val != null &&
      val._id != null &&
      this.entity != null &&
      this.entity._id != undefined
    ) {
      if (val._id === this.entity._id) {
        return true;
      }
    }
    return false;
  }

  @Watch("corp", { immediate: true })
  async onCorpChange(val) {
    await this.init(val);
  }
}
</script>

<style scoped>
.filterBox {
  position: sticky;
  background: white;
  top: 0;
  width: 100%;
  z-index: 1;
  height: 50px;
  border-bottom: 1px solid #dfdfdf;
}

.v-select-list {
  padding: 0;
}
.menuable__content__active,
.v-menu__content {
  background: white;
}
.v-select__selections {
  height: 32px;
}
.height32 {
  height: 32px;
}
.text-title {
  min-width: 100px;
  float: left;
  margin: 4px 0;
  line-height: 1.2;
  font-weight: 400;
  font-size: 14px;
}
</style>
